import React from 'react';
import { createRoot } from 'react-dom/client';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import App from './App';
import { initI18n } from './i18n/config';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import registerServiceWorker from './registerServiceWorker';

// FontAwesome injects its sizing CSS via a JS-created <style> tag by default, which has
// no nonce and gets blocked by our style-src CSP in production. Disable that auto-injection
// and load the stylesheet as a static asset (via <link>, unaffected by style-src) instead.
config.autoAddCss = false;

const cspNonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') || undefined;

const emotionCache = createCache({
  key: 'css',
  nonce: cspNonce,
});

const start = async () => {
  await initI18n();

  const container = document.getElementById('root');

  const root = createRoot(container!);

  root.render(
    <CacheProvider value={emotionCache}>
      <App />
    </CacheProvider>
  );
};
start();
//registerServiceWorker();
